var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"map"},_vm._l((_vm.map),function(row,i){return _c('div',{key:i,staticClass:"row"},_vm._l((row),function(cell,j){return _c('div',{key:j,staticClass:"cell",class:{obstacle: cell === 1, los: cell === 2, red: cell === 3},on:{"click":function($event){return _vm.clickCell(j, i)}}})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }